// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3jZgk","choiceBoxes":"toolbarselects_choiceBoxes__2YDdF","simpleField":"toolbarselects_simpleField__9rBwj"};